import { useEffect, useRef } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Experience from "@/components/Experience";
import About from "@/components/About";
import Gallery from "@/components/Gallery";
import Journal from "@/components/Journal";
import Inquiry from "@/components/Inquiry";
import Footer from "@/components/Footer";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.4, smoothWheel: true });
    lenisRef.current = lenis;
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (target) => {
    lenisRef.current?.scrollTo(target, { duration: 1.6 });
  };

  return (
    <div className="App bg-[#121212] text-white min-h-screen font-sans">
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#121212",
            border: "1px solid rgba(255,255,255,0.15)",
            color: "#F5F5F7",
            borderRadius: 0,
            fontFamily: "Inter, sans-serif",
            fontWeight: 300,
          },
        }}
      />
      <Nav onNavigate={scrollTo} />
      <main>
        <Hero />
        <Marquee />
        <Experience />
        <About onNavigate={scrollTo} />
        <Gallery />
        <Journal />
        <Inquiry />
      </main>
      <Footer />
    </div>
  );
}

export default App;
